import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BASE_URL } from '../constants/apiConstants';
import axiosInstance from '../api/axios';

interface Ipayload {
  userid: string | null,
  fromdate: string,
  todate: string,
  sitecode: any,
  cafecode: any,
  MenuPlanTypeId?: string;
}

const initialState: any = {
  projectionData: [],
  ismppublished: false,
  loading: false,
  error: null,
  cutoffdate: null,
  itemdisplayid: null,
  itemdisplayname: null
};

interface projectionData {
  dayparts: any;
  ismppublished?: boolean;
  ismpspublished?: boolean;
  cutoffdate: string;
  itemdisplayid?: number;
  itemdisplayname?: string;
}

export const fetchItemMenuProjectionSelectionData = createAsyncThunk<projectionData, Ipayload>(
  'projections/fetchItemMenuProjectionSelectionData',
  async (payload) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/ItemWisePlanning/MenuProjectionSelectionItemWise/GetMenuProjectionSelectionRegularItemWise`, payload);
    return response.data.data;
  }
);

export const ItemSaveMenuProjectionSelection = createAsyncThunk(
  'MenuProjection/ItemSaveMenuProjectionSelection',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/ItemWisePlanning/MenuProjectionSelectionItemWise/SaveMenuProjectionSelectionItemWise`, payload);
    return response?.data?.data;
  }
);

// export const fetchMenuProjectionExportData = createAsyncThunk<projectionData, Ipayload>(
//   'projections/fetchMenuProjectionExportData',
//   async (payload) => {
//     const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/MenuProjection/GetMenuProjectionReport`, payload);
//     return response.data.data;
//   }
// );

const itemProjectionSelectionDataSlice = createSlice({
  name: 'ItemMenuProjectionSelectionData',
  initialState,
  reducers: {
    updateProjectionData: (state, action) => {
      state.projectionData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchItemMenuProjectionSelectionData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchItemMenuProjectionSelectionData.fulfilled, (state, action) => {
        state.loading = false;
        state.projectionData = [...action.payload.dayparts];
        // API may return either `ismppublished` or `ismpspublished`.
        // Keep state key as `ismppublished` to avoid breaking existing UI usage.
        state.ismppublished =
          action.payload.ismpspublished ??
          action.payload.ismppublished ??
          false;
        state.cutoffdate = action.payload.cutoffdate;
        state.itemdisplayid = action.payload.itemdisplayid;
        state.itemdisplayname = action.payload.itemdisplayname;
      })
      .addCase(fetchItemMenuProjectionSelectionData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(ItemSaveMenuProjectionSelection.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(ItemSaveMenuProjectionSelection.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    // builder
    //   .addCase(fetchMenuProjectionExportData.pending, (state) => {
    //     state.loading = true;
    //   })
    //   .addCase(fetchMenuProjectionExportData.fulfilled, (state) => {
    //     state.loading = false;
    //   })
    //   .addCase(fetchMenuProjectionExportData.rejected, (state, action) => {
    //     state.loading = false;
    //     state.error = action.error.message;
    //   });
  },
});

export const { updateProjectionData } = itemProjectionSelectionDataSlice.actions;
export default itemProjectionSelectionDataSlice.reducer;
